import React, { useState } from 'react'
import Header from '../shared/header/Header'
import Sidebar from '../shared/sidebar/Sidebar';
import { Outlet } from 'react-router';

const Layout = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div>
      <div className="flex overflow-hidden"
        style={{ height: "calc(100dvh / 0.85)" }}
      >
        {/* Sidebar */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-hidden bg-[#FAFAFA]"
          style={{ height: "calc(100dvh / 0.85)" }}
        >
          {/*  Site header */}
          <Header />

          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default Layout;
